import { default as app_45errorlKdlKmsZbDMeta } from "/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/app-error.vue?macro=true";
import { default as _91id_93jOmFR87FDUMeta } from "/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/detailsCast/[id].vue?macro=true";
import { default as _91id_93Bpuhkk90p5Meta } from "/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/detailsPrograms/[id].vue?macro=true";
import { default as _91id_93cWssR3PVs5Meta } from "/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/detailsVodMovies/[id].vue?macro=true";
import { default as _91id_93WKZdjU6xKNMeta } from "/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/detailsVodSeries/[id].vue?macro=true";
import { default as indexEY3BZC7bCPMeta } from "/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/guide/index.vue?macro=true";
import { default as index9rDx2faw3nMeta } from "/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/help/index.vue?macro=true";
import { default as indexYBvVdLLcuEMeta } from "/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/home/index.vue?macro=true";
import { default as show_45allCX2GBxY4YvMeta } from "/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/home/show-all.vue?macro=true";
import { default as index01slPxQn4iMeta } from "/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/index.vue?macro=true";
import { default as forgotOrKHVV2tC8Meta } from "/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/login/forgot.vue?macro=true";
import { default as indexoWwzNuXbqbMeta } from "/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/login/index.vue?macro=true";
import { default as sign_45ineQIKqfhxMbMeta } from "/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/login/sign-in.vue?macro=true";
import { default as welcomendh1E6xahGMeta } from "/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/login/welcome.vue?macro=true";
import { default as all_45on_45demandSEKLwsCx29Meta } from "/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/mytv/all-on-demand.vue?macro=true";
import { default as all_45programsQausyYowA3Meta } from "/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/mytv/all-programs.vue?macro=true";
import { default as indexm0O8gzEx9cMeta } from "/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/mytv/index.vue?macro=true";
import { default as show_45all_45fav_45channelsVi4UBmNmM0Meta } from "/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/mytv/show-all-fav-channels.vue?macro=true";
import { default as index2UR1kXxIg6Meta } from "/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/player/index.vue?macro=true";
import { default as playerNT5p7MlnEwMeta } from "/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/player.vue?macro=true";
import { default as indexwhAOA47KZIMeta } from "/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/search/index.vue?macro=true";
import { default as show_45alleaiDwZaJuNMeta } from "/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/search/show-all.vue?macro=true";
import { default as about_45usr7PRRnLPtsMeta } from "/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/about-us.vue?macro=true";
import { default as index9gHMStutcYMeta } from "/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/account/index.vue?macro=true";
import { default as clear_45cachedPQwbVNnpJMeta } from "/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/clear-cache.vue?macro=true";
import { default as dev_45mode0gmNDQl2ylMeta } from "/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/dev-mode.vue?macro=true";
import { default as favoritesPiEWKJKnWTMeta } from "/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/favorites.vue?macro=true";
import { default as indexyUbrmTSBctMeta } from "/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/language/index.vue?macro=true";
import { default as indexgx8ogQci4DMeta } from "/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/parent-control/index.vue?macro=true";
import { default as indexps1VgEf5yfMeta } from "/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/player/index.vue?macro=true";
import { default as privacy_45policyjaoYAXB0XyMeta } from "/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/privacy-policy.vue?macro=true";
import { default as subscriptionA3FoyNtkmeMeta } from "/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/subscription.vue?macro=true";
import { default as settingsNYOZCok2ntMeta } from "/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings.vue?macro=true";
import { default as loadertTDS0Rk80rMeta } from "/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/splash/loader.vue?macro=true";
import { default as logo3r5k6WJvEgMeta } from "/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/splash/logo.vue?macro=true";
import { default as maxidfvPckSqnmMeta } from "/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/splash/maxi.vue?macro=true";
import { default as indexImjx3UHLb3Meta } from "/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/trailer/index.vue?macro=true";
import { default as _91id_93lbJLipBW3JMeta } from "/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/detail-genre/[id].vue?macro=true";
import { default as _91id_933TgSooTZCCMeta } from "/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/genres-premium/[id].vue?macro=true";
import { default as _91id_93YSdrCUOKfyMeta } from "/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/genres/[id].vue?macro=true";
import { default as indexhUlzY0VnQ0Meta } from "/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/index.vue?macro=true";
import { default as show_45all_45channelsPucszN9VlDMeta } from "/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/show-all-channels.vue?macro=true";
import { default as show_45all_45moviesigwCXKfnSiMeta } from "/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/show-all-movies.vue?macro=true";
import { default as show_45all_45subitemsbioH3nFHtyMeta } from "/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/show-all-subitems.vue?macro=true";
import { default as show_45allmKasDSd9MqMeta } from "/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/show-all.vue?macro=true";
export default [
  {
    name: "app-error",
    path: "/app-error",
    meta: app_45errorlKdlKmsZbDMeta || {},
    component: () => import("/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/app-error.vue").then(m => m.default || m)
  },
  {
    name: "detailsCast-id",
    path: "/detailsCast/:id()",
    meta: _91id_93jOmFR87FDUMeta || {},
    component: () => import("/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/detailsCast/[id].vue").then(m => m.default || m)
  },
  {
    name: "detailsPrograms-id",
    path: "/detailsPrograms/:id()",
    meta: _91id_93Bpuhkk90p5Meta || {},
    component: () => import("/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/detailsPrograms/[id].vue").then(m => m.default || m)
  },
  {
    name: "detailsVodMovies-id",
    path: "/detailsVodMovies/:id()",
    meta: _91id_93cWssR3PVs5Meta || {},
    component: () => import("/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/detailsVodMovies/[id].vue").then(m => m.default || m)
  },
  {
    name: "detailsVodSeries-id",
    path: "/detailsVodSeries/:id()",
    meta: _91id_93WKZdjU6xKNMeta || {},
    component: () => import("/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/detailsVodSeries/[id].vue").then(m => m.default || m)
  },
  {
    name: "guide",
    path: "/guide",
    meta: indexEY3BZC7bCPMeta || {},
    component: () => import("/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/guide/index.vue").then(m => m.default || m)
  },
  {
    name: "help",
    path: "/help",
    meta: index9rDx2faw3nMeta || {},
    component: () => import("/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/help/index.vue").then(m => m.default || m)
  },
  {
    name: "home",
    path: "/home",
    meta: indexYBvVdLLcuEMeta || {},
    component: () => import("/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/home/index.vue").then(m => m.default || m)
  },
  {
    name: "home-show-all",
    path: "/home/show-all",
    meta: show_45allCX2GBxY4YvMeta || {},
    component: () => import("/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/home/show-all.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    meta: index01slPxQn4iMeta || {},
    component: () => import("/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "login-forgot",
    path: "/login/forgot",
    meta: forgotOrKHVV2tC8Meta || {},
    component: () => import("/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/login/forgot.vue").then(m => m.default || m)
  },
  {
    name: "login",
    path: "/login",
    meta: indexoWwzNuXbqbMeta || {},
    component: () => import("/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/login/index.vue").then(m => m.default || m)
  },
  {
    name: "login-sign-in",
    path: "/login/sign-in",
    meta: sign_45ineQIKqfhxMbMeta || {},
    component: () => import("/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/login/sign-in.vue").then(m => m.default || m)
  },
  {
    name: "login-welcome",
    path: "/login/welcome",
    meta: welcomendh1E6xahGMeta || {},
    component: () => import("/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/login/welcome.vue").then(m => m.default || m)
  },
  {
    name: "mytv-all-on-demand",
    path: "/mytv/all-on-demand",
    meta: all_45on_45demandSEKLwsCx29Meta || {},
    component: () => import("/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/mytv/all-on-demand.vue").then(m => m.default || m)
  },
  {
    name: "mytv-all-programs",
    path: "/mytv/all-programs",
    meta: all_45programsQausyYowA3Meta || {},
    component: () => import("/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/mytv/all-programs.vue").then(m => m.default || m)
  },
  {
    name: "mytv",
    path: "/mytv",
    meta: indexm0O8gzEx9cMeta || {},
    component: () => import("/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/mytv/index.vue").then(m => m.default || m)
  },
  {
    name: "mytv-show-all-fav-channels",
    path: "/mytv/show-all-fav-channels",
    meta: show_45all_45fav_45channelsVi4UBmNmM0Meta || {},
    component: () => import("/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/mytv/show-all-fav-channels.vue").then(m => m.default || m)
  },
  {
    name: playerNT5p7MlnEwMeta?.name,
    path: "/player",
    meta: playerNT5p7MlnEwMeta || {},
    component: () => import("/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/player.vue").then(m => m.default || m),
    children: [
  {
    name: "player",
    path: "",
    component: () => import("/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/player/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "search",
    path: "/search",
    meta: indexwhAOA47KZIMeta || {},
    component: () => import("/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/search/index.vue").then(m => m.default || m)
  },
  {
    name: "search-show-all",
    path: "/search/show-all",
    meta: show_45alleaiDwZaJuNMeta || {},
    component: () => import("/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/search/show-all.vue").then(m => m.default || m)
  },
  {
    name: "settings",
    path: "/settings",
    component: () => import("/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings.vue").then(m => m.default || m),
    children: [
  {
    name: "settings-about-us",
    path: "about-us",
    component: () => import("/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/about-us.vue").then(m => m.default || m)
  },
  {
    name: "settings-account",
    path: "account",
    component: () => import("/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/account/index.vue").then(m => m.default || m)
  },
  {
    name: "settings-clear-cache",
    path: "clear-cache",
    component: () => import("/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/clear-cache.vue").then(m => m.default || m)
  },
  {
    name: "settings-dev-mode",
    path: "dev-mode",
    component: () => import("/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/dev-mode.vue").then(m => m.default || m)
  },
  {
    name: "settings-favorites",
    path: "favorites",
    component: () => import("/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/favorites.vue").then(m => m.default || m)
  },
  {
    name: "settings-language",
    path: "language",
    component: () => import("/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/language/index.vue").then(m => m.default || m)
  },
  {
    name: "settings-parent-control",
    path: "parent-control",
    component: () => import("/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/parent-control/index.vue").then(m => m.default || m)
  },
  {
    name: "settings-player",
    path: "player",
    component: () => import("/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/player/index.vue").then(m => m.default || m)
  },
  {
    name: "settings-privacy-policy",
    path: "privacy-policy",
    component: () => import("/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: "settings-subscription",
    path: "subscription",
    component: () => import("/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/settings/subscription.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "splash-loader",
    path: "/splash/loader",
    component: () => import("/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/splash/loader.vue").then(m => m.default || m)
  },
  {
    name: "splash-logo",
    path: "/splash/logo",
    component: () => import("/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/splash/logo.vue").then(m => m.default || m)
  },
  {
    name: "splash-maxi",
    path: "/splash/maxi",
    component: () => import("/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/splash/maxi.vue").then(m => m.default || m)
  },
  {
    name: "trailer",
    path: "/trailer",
    meta: indexImjx3UHLb3Meta || {},
    component: () => import("/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/trailer/index.vue").then(m => m.default || m)
  },
  {
    name: "vod-detail-genre-id",
    path: "/vod/detail-genre/:id()",
    meta: _91id_93lbJLipBW3JMeta || {},
    component: () => import("/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/detail-genre/[id].vue").then(m => m.default || m)
  },
  {
    name: "vod-genres-premium-id",
    path: "/vod/genres-premium/:id()",
    meta: _91id_933TgSooTZCCMeta || {},
    component: () => import("/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/genres-premium/[id].vue").then(m => m.default || m)
  },
  {
    name: "vod-genres-id",
    path: "/vod/genres/:id()",
    meta: _91id_93YSdrCUOKfyMeta || {},
    component: () => import("/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/genres/[id].vue").then(m => m.default || m)
  },
  {
    name: "vod",
    path: "/vod",
    meta: indexhUlzY0VnQ0Meta || {},
    component: () => import("/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/index.vue").then(m => m.default || m)
  },
  {
    name: "vod-show-all-channels",
    path: "/vod/show-all-channels",
    meta: show_45all_45channelsPucszN9VlDMeta || {},
    component: () => import("/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/show-all-channels.vue").then(m => m.default || m)
  },
  {
    name: "vod-show-all-movies",
    path: "/vod/show-all-movies",
    meta: show_45all_45moviesigwCXKfnSiMeta || {},
    component: () => import("/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/show-all-movies.vue").then(m => m.default || m)
  },
  {
    name: "vod-show-all-subitems",
    path: "/vod/show-all-subitems",
    meta: show_45all_45subitemsbioH3nFHtyMeta || {},
    component: () => import("/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/show-all-subitems.vue").then(m => m.default || m)
  },
  {
    name: "vod-show-all",
    path: "/vod/show-all",
    meta: show_45allmKasDSd9MqMeta || {},
    component: () => import("/Users/devops/buildAgent/work/f6010d7a8f2d88ad/applications/smart-application/pages/vod/show-all.vue").then(m => m.default || m)
  }
]